import { render, staticRenderFns } from "./DuplicatesDetailsOriginal.vue?vue&type=template&id=2777daac&"
import script from "./DuplicatesDetailsOriginal.vue?vue&type=script&lang=js&"
export * from "./DuplicatesDetailsOriginal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports